export default "__VITE_PUBLIC_ASSET__40cd0e8c__"